export default "__VITE_ASSET__Bonr$u2I__"